import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserStateService } from 'src/app/Services/commonservice.service';
import { ConfirmationServiceService } from 'src/app/Services/confirmation-service.service';
import { Tooltip } from 'bootstrap';


@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
})
export class LayoutComponent {
  messages = '';

  constructor(private router: Router,private userStateService: UserStateService, private confirmDialogService:ConfirmationServiceService  ) {}
personalSetting = false;
lastname=''
usermail=''
username=''
UserId=0
subSetting = false;
profilePhotoUrl=''
profileImage: string = '/assets/bookingIcon/touristUser.jpg'; // fallback
displayName: string|null='';


ngOnInit(): void {


   
  this.userStateService.profileImage$.subscribe((url) => {
    this.profileImage = url || '/assets/bookingIcon/touristUser.jpg';
  });
  this.userStateService.displayName$.subscribe(name => {

  this.displayName=name
});

  this.setMessageBasedOnRoute(this.router.url);
}


  
  setMessageBasedOnRoute(url: string) {
    debugger
    if (url.includes('/dashboard')) {
      this.messages = 'Dashboard';
    } 
    else if (url.includes('/user')) {
      this.messages = 'User Management';
    }
     else if (url.includes('/booking')) {
      this.messages = 'Booking Management';
    } 
    else if (url.includes('/finance')) {
      this.messages = 'Financial Overview';
    }
     else if (url.includes('/helpsupport')) {

      this.messages = 'Help & Support';
    }
    else if (url.includes('/subsetting')) {

      this.messages = 'Settings';
    }
    else if (url.includes('/contentmanager')) {

      this.messages = 'Content Manager';
    }


    
     else {
      this.messages = ''; 
    }
  }

  toggleSubSetting() {
    this.personalSetting = !this.personalSetting;
    
  }
  logout() {
  this.confirmDialogService.openConfirmDialog(`Are you sure you want to log out?
You’ll need to sign in again to access the admin dashboard.`, () => {
  sessionStorage.clear();  
  localStorage.clear();



  
  this.router.navigate(['/login']);
},'assets/LayoutIcon/out.png')}

}
